import { Modal } from "antd";
import { useContext } from "react";
import SL_Button from "../../../components/buttons/Button";
import GeneralContext from "../../../context/GeneralContext/GeneralContext";
import api from "../../../services/api";
import { displayMessage } from '../../../helpers/messages'


export function ResetUserPasswordModal({ user: { id, full_name }, onCloseModal }) {

    const {
        setShowLoading,
    } = useContext(GeneralContext)

    async function onClickResetUserPassword() {
        setShowLoading(true)

        try {
            await api.auth.resetPassword(id)
            onCloseModal()
        } finally {
            setShowLoading(false)
        }
    }

    return (
        <Modal
            title={<div className="text-xl font-bold text-fit-red-900">{displayMessage('RESET_PASSWORD')}</div>}
            open={true}
            onCancel={onCloseModal}
            centered={true}
            footer={
                <div className='flex justify-end'>
                    <SL_Button className="w-[150px] bg-gray-500 border-transparent" onClick={onCloseModal}>{displayMessage('CLOSE')}</SL_Button>

                    <SL_Button className="w-[150px]" onClick={onClickResetUserPassword}>{displayMessage('CONFIRM')}</SL_Button>
                </div>
            }
            maskClosable={false}
            width={500}
        >
            <div className="text-base text-fit-red-900 font-semibold">{displayMessage('RESET_PASSWORD_USER_CONFIRM')}</div>

            <div className="text-base text-fit-red-900 text-center">{full_name}</div>
        </Modal>
    )
}